import { render, staticRenderFns } from "./headerCustom.vue?vue&type=template&id=db18001a&"
import script from "./headerCustom.vue?vue&type=script&lang=js&"
export * from "./headerCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports